import script from "./RegionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionInfo.vue?vue&type=script&setup=true&lang=js"

import "./RegionInfo.vue?vue&type=style&index=0&id=3f71221b&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f71221b"]])

export default __exports__